<template>
  <div class="preview-messages-container messages-container">
    <div
      class="preview-message-cont px-2"
      v-for="(message, index) in messages"
      :key="`message-${index}`"
    >
      <div class="d-flex">
        <!-- <div class="mr-2">
          <div class="author-avatar">
            {{ userNameChat(message.author).charAt(0) }}
          </div>
        </div> -->
        <div>
          <div
            v-if="message.author.organization_name"
            class="org-name"
          >
            {{ message.author.organization_name }}
          </div>
          <div class="d-flex align-center" style="line-height: 1.2;">
            <div class="message-author mr-2">
              {{ userNameChat(message.author) }}
            </div>
            <div @click="messagetoRespond(message)">
              <Icon
                class="reply-btn"
                color="white"
                icon="corner-up-left-alt"
                :size="18"
                :viewBox="16"
              />
            </div>
          </div>
          <div
            v-if="message.parent"
            class="reply pl-2 mb-1"
          >
            <div>Respuesta a {{ message.parent.author_name }}</div>
            <div class="data">{{ message.parent.message }}</div>
          </div>
          <div class="message data" style="line-height: 1.3;" v-html="message.message"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  watch: {
    messages: function () {
      this.updateScroll()
    }
  },
  computed: {
    messages() {
      return this.$store.state.rooms.item.chat.messages
    }
  }
})
export default class MessagesPreview extends Vue {
  creationTime(date) {
    const creationTime = new Date(date)
    const minutes = creationTime.getMinutes()
    return `${creationTime.getHours()}:${minutes < 10 ? '0' : ''}${minutes}`
  }

  updateScroll() {
    setTimeout(() => {
      const lastMessageElement = document.querySelector('.preview-message-cont:last-child')
      if (lastMessageElement) {
        lastMessageElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'end' })
      }
    }, 100)
  }

  messagetoRespond(parentMessage) {
    this.$emit('messagetoRespond', parentMessage)
  }

  userNameChat(author) {
    const userName = author.name === '' ? author.email : author.name
    return !userName ? 'Espectador' : userName
  }
}
</script>

<style scoped>
.preview-messages-container {
  max-height: 160px !important;
  overflow: hidden;
}

.messages-container {
  overflow-y: scroll;
  scrollbar-color: rgb(161, 161, 161) rgba(163, 163, 163, 0.514);
  scrollbar-width: thin;
}

.preview-message-cont {
  margin-bottom: 15px !important;
}

.preview-message-cont:last-child {
  margin-bottom: 0px !important;
}

.message-card .w-100 {
  width: 100%;
}

.message {
  font-size: 14px;
  color: #fff;
  text-shadow: 1px 1px 1px rgb(29, 29, 29);
}

.message.data {
  color: white;
  max-width: 600px;
}

.reply-btn {
  transition: all .2s;
  opacity: .5;
  padding: 0;
  margin: 0;
  cursor: pointer;
}

.reply-btn:hover {
  opacity: 1;
}

.message-author {
  color: white;
  opacity: .8;
  font-size: 14px;
  text-shadow: 1px 1px 1px rgb(29, 29, 29);
}

.author-avatar {
  width: 20px;
  height: 20px;
  color: rgb(65, 63, 63);
  background-color: #d1d1d1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  margin-top: 2px;
}

.reply {
  color: #d1d1d1;
  text-shadow: 1px 1px 1px rgb(29, 29, 29);
  font-size: 14px;
}

.reply .data {
  color: white;
}
/* .reply p {
  text-shadow: 1px 1px 2px rgb(29, 29, 29);
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 90%;
  overflow: hidden;
  font-size: 8px;
} */
.name {
  overflow: hidden;
  margin: -6px 0;
  align-items: center;
}
.org-name {
  font-size: 14px;
  color: #ffffff;
  display: block;
  text-shadow: 1px 1px 1px rgb(29, 29, 29);
}
.header-data {
  position: absolute;
  top: 5px;
  right: -15px;
  display: flex;
  align-items: top;
  font-size: 13px;
}

::-webkit-scrollbar {
  width: 3px !important;
  height: 5px !important;
}

::-webkit-scrollbar-track {
  background-color: rgba(163, 163, 163, 0.514);
  padding: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: rgb(161, 161, 161);
  border-radius: 10px;
  padding: 10px;
  transition: all 0.2s;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgb(191, 191, 191);
}
</style>
